<template>
  <div class="namespace-form">
    <h3 class="title title-login">{{ $t('login.action.chooseYourTeam') }}</h3>
    <ul class="list-group list-group-gap">
      <li class="list-group-item bg-blue-grey-100" v-for="(team, index) in teams">
        <a class="btn btn-block btn-team text-xs-left media" ng-if="team" v-on:click="selectTeam(team.namespace)">
          <div class="media-left">
            <span class="avatar avatar-online">
              <img class="img-fluid" src="/static/images/user.png">
            </span>
          </div>
          <div class="media-body">
            <h4 class="media-heading"><span class="text-uppercase blue-600">{{ team.name }}</span> Team</h4>
            <p>{{ `${baseURL}/${team.namespace}` }}</p>
          </div>
          <div class="media-right align-middle">
            <i class="icon md-chevron-right" aria-hidden="true"></i>
          </div>
        </a>
      </li>
    </ul>
    <div class="login-help">
      <p><strong>{{ $t('text.or') }}</strong></p>
      <a href="javascript:void(0)" v-on:click="loginOtherTeamClick">{{ $t('login.action.loginOtherTeam') }}</h3></a>
    </div>
  </div>
</template>

<script>
import AuthManager from 'src/managers/AuthManager';

export default {
  props: {
    teams: {
      type: Array,
    },
  },
  computed: {
    baseURL: () => process.env.BASE_URL,
  },
  data: function() {
    return {
      authManager: null,
    };
  },
  created: function() {
    this.authManager = new AuthManager();
  },
  methods: {
    selectTeam: function(namespace) {
      if (this.authManager.isOauthFromOtherService(this.$route.query)) {
        this.authManager.getAccessToken(namespace).then((credential) => {
          this.$emit('selectTeam', credential);
        });
      } else {
        // redirect to dashboard
        this.$router.push(`/${namespace}`);
      }
    },
    loginOtherTeamClick: function() {
      this.$emit('loginOtherTeam');
    },
  },
};
</script>

<style lang="scss" scoped>
.list-group-item {
  border-radius: .286rem;
  padding: 0;
}

.btn-team {
  background-color: initial;
  padding: 0.75rem 1.25rem;
  margin-left: 0;

  &:hover {
    color: #ffffff !important;
    background-color: #00A6ED;

    span,
    p,
    .media-heading {
      color: #ffffff !important;
    }
  }
}

.media-body {
  p {
    margin-bottom: 0;
  }
}

.media-right {
  vertical-align: middle;
  .icon {
    font-size: 24px;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// TeamListForm.vue?75639684